<template>
  <div class="progress-bar-container">
    <div class="progress-bar" :style="{ width: progress + '%' }"></div>
  </div>
</template>

<script>
export default {
  props: {
    progress: Number,
  },
};
</script>

<style>
.progress-bar-container {
  width: 100%;
  background-color: #e5e5e5;
}
.progress-bar {
  height: 5px;
  background-color: #4caf50;
}
</style>
